import styled from '@emotion/styled'

import { Spacing } from '../../enums/spacing'
import { ButtonsGroup } from '../ButtonsGroup'

export const PaginationWrapper = styled.section`
  display: flex;
  align-items: center;
`

export const PaginationList = styled(ButtonsGroup)`
  flex-shrink: 0;
  margin-right: ${Spacing.S8};
  margin-left: ${Spacing.S8};
`
